module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.detailLayout) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 leftChart"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-bar-eri', {
    attrs: {
      "chart-data": _vm.barChartData,
      "width": 50,
      "height": 280
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-tag",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatDecimal")((this.fetchData.eriPercentageWarehouse || 0))) + "%\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 chartPadding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-line-eri', {
    attrs: {
      "chart-data": _vm.lineChartData,
      "height": 240
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "240px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "120px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "Recibidos",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuSquareQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Cuadradas")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuInventoryQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Inventariadas")])])])])])])])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('chart-bar-eri', {
    attrs: {
      "chart-data": _vm.barChartData,
      "width": 50,
      "height": 280
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-tag",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatDecimal")((this.fetchData.eriPercentageWarehouse || 0))) + "%\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "width": "240px",
      "padding-top": "120px"
    }
  }, [_c('div', {
    staticClass: "pull-left text-center",
    staticStyle: {
      "width": "120px",
      "border-right": "1px solid #eee"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/static/img/icons/ic_storage_arrived@3x.png",
      "alt": "ERI",
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value",
    style: (_vm.formatAmountColor(this.fetchData.eriPercentageWarehouse))
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuSquareQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Cuadradas")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullseye"
  }), _vm._v(" "), _c('span', {
    staticClass: "span-value"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("formatAmount")(this.fetchData.skuInventoryQuantityWarehouse))), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(this.fetchData.minimumStockUnit))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("SKU Cant.")]), _vm._v(" "), _c('span', {
    staticClass: "span-status"
  }, [_vm._v("Inventariadas")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/eri_ciclico.png"
    }
  }), _vm._v(" ERI Cíclico")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e783b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/EriMain.vue
// module id = 506
// module chunks = 1